export const FRIEND = 1;
export const THEY_REQUESTED = 4;
export const YOU_REQUESTED = 3;
export const NOT_FRIEND = 2;

export const FRIEND_REQUESTS = [
  YOU_REQUESTED,
  THEY_REQUESTED,
];
